import { render } from "./FieldRadio.vue?vue&type=template&id=277b8014"
import script from "./FieldRadio.vue?vue&type=script&lang=js"
export * from "./FieldRadio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__